import { Link, useParams } from "@tanstack/react-router";

import page from "../actors/actors.module.css";
import { SoonControl } from "../Soon";
import { AD_STATIC_TYPES, PRODUCT_VIDEO_TYPES, TALKING_TYPES, useOwnPictures } from "./home-pictures";
import { MakeTile, type MakeTileId } from "./make-tiles";
import classes from "./simple-sections.module.css";

const ROUTE = "/signed-in/teams/$teamId/brands/$brandId/studio/simple/ads";

/** The prototype's "Make ads" (`ADS_GROUP`, then its copy and template tiles), in its order. */
const MAKE_ADS: readonly MakeTileId[] = ["set", "ugc", "static", "animate", "winner", "storyboard", "copy", "templates"];

/** Make ads: the flows the app has, and Coming soon where it has none yet (spec ui-perf/simple-ads). */
function MakeAds({ teamId, brandId }: { teamId: string; brandId: string }) {
  // Home's own reads (5 a page, the composers' keys), so the pictures cost no request here.
  const own: Partial<Record<MakeTileId, ReturnType<typeof useOwnPictures>>> = {
    ugc: useOwnPictures(teamId, brandId, TALKING_TYPES),
    static: useOwnPictures(teamId, brandId, AD_STATIC_TYPES),
    animate: useOwnPictures(teamId, brandId, PRODUCT_VIDEO_TYPES),
  };
  return (
    <section aria-labelledby="simple-make-ads">
      <h2 id="simple-make-ads" className={classes.sectionTitle}>
        Make ads
      </h2>
      <div className={classes.tiles}>
        {MAKE_ADS.map((id) => (
          <MakeTile key={id} id={id} teamId={teamId} brandId={brandId} own={own[id]} />
        ))}
      </div>
    </section>
  );
}

/**
 * Simple's Ads (spec ui-perf/simple-ads): the Created AI Simple prototype's `VIEWS.ads`, opened on
 * its Create tab; Overview (the ads' results) and Ideas from other brands need the ads area, not
 * built, so their tabs are Coming soon.
 */
export function SimpleAds() {
  const { teamId, brandId } = useParams({ from: ROUTE });
  return (
    <div className={classes.page}>
      <h1 className={classes.title}>Ads</h1>
      <nav className={`${page.tabs} ${classes.pageTabs}`} aria-label="Ads tabs">
        <SoonControl className={page.tab}>Overview</SoonControl>
        <Link
          to="/teams/$teamId/brands/$brandId/simple/ads"
          params={{ teamId, brandId }}
          className={page.tab}
          aria-current="page"
          activeOptions={{ exact: true }}
        >
          Create
        </Link>
        <SoonControl className={page.tab}>Ideas from other brands</SoonControl>
      </nav>
      <MakeAds teamId={teamId} brandId={brandId} />
    </div>
  );
}
